import * as React from "react";
import { connect } from "react-redux";
import DatePicker from "../common/DatePicker";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MiniSpinner from "../common/MiniSpinner";
import { getDirectionsUrl } from "../../helpers/location";
import Covid19AppointmentError from '../appointments/Covid19AppointmentError';
const DATE_FORMAT = Tools.getDateFormats();
import moment from 'moment-timezone';

class Covid19VaccineAppointmentInfo extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lastSelectedMonth: -1,
            selectedCalendarDate: null,
            showAsInvalid: false,
            selectedSlot: null,
            selectedCalendarDay: null,
            providerMessage: ""
        };
        this.mounted = false;
        this.timeSelected = false;
        this.selectedMonthData = [];
        this.redirectToMap = this.redirectToMap.bind(this);
        this.getSlotsForMonth = this.getSlotsForMonth.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.CovidVaccine.AppointmentInfo.ComponentWillMount", new Date(), Tools.getURLPath());
        this.mounted = true;
    }

    redirectToMap(item){
        logUI("MBHWeb.UI.CovidVaccine.AppointmentInfo.redirectToMap", new Date(), Tools.getURLPath())
        const { locationStreet1, locationStreet2, locationCity, locationState, locationZip } = item;
        if (locationStreet1) {
            const toAddress = locationStreet2 ? `${locationStreet1}, ${locationStreet2}, ${locationCity}, ${locationState} ${locationZip}` : `${locationStreet1}, ${locationCity}, ${locationState} ${locationZip}`;
            var addressUrl = getDirectionsUrl(null, toAddress);
            if (typeof window !== 'undefined' && addressUrl) {
                window.open(addressUrl, "_blank");
            }
        }
    }

    getSlotsForMonth(selectedMonth){
        const { visit } = this.props;
        if (!this.visitDataForProvider) return null;
        const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        const dt = visit && visit.startTime ? new Date(visit.startTime) : new Date();
        const currentMonth = monthNames[selectedMonth > -1 ? selectedMonth : dt.getMonth()];
        let schedule = this.visitDataForProvider[currentMonth];
        // arrange the date present in schedule in ascending order
        if (!schedule || schedule.length === 0) return null;
        if (schedule && schedule.length > 0) {
            schedule = [].concat(schedule).sort((schedule1, schedule2) => {
                const dateA = schedule1.date;
                const dateB = schedule2.date;
                return dateA < dateB ? -1 : 1;
            });
        }
        return schedule;//.times;             
    }

    getVisitDataForProvider = (providerData) => {
        const locations = providerData && providerData.provider && providerData.provider.locations && providerData.provider.locations.length > 0 ? providerData.provider.locations : [];
        const openSchedule = locations && locations.length > 0 && locations[0].openSchedules && locations[0].openSchedules.dateAndTimes && locations[0].openSchedules.dateAndTimes.length > 0 ? locations[0].openSchedules.dateAndTimes : [];
        const visitDataForProvider = openSchedule && openSchedule.length > 0 && openSchedule.reduce((acc, schedule) => {
            let { date, dayString, dateString, times, providerMessage } = schedule;
            dateString = dateString.slice(0, 3);
            return {
                ...acc,
                [dateString]: [...(acc[dateString] || []), { date, times, providerMessage }],
            };
        }, {});
        return visitDataForProvider;
    }

    componentWillUnmount() {
        this.mounted = false;
        logUI("MBHWeb.UI.CovidVaccine.AppointmentInfo.ComponentWillUnMount", new Date(), Tools.getURLPath());
    }

    doReviewAndSubmit = () => {
        this.props.saveSlot(this.state.selectedSlot, this.state.providerMessage);
        logUI("MBHWeb.UI.CovidVaccine.AppointmentInfo.DoReviewAndSubmit", new Date(), Tools.getURLPath());
    }

    parseDate = strDate => {
        // stupid javascript dates
        if (!strDate) {
            let today = Tools.toJSDate(new Date());
            strDate = Tools.dateSimpleFormat(today);
        }
        let parts = strDate.split("-");
        return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    }

    containsDate = (ar, dt) => {
        let ret = false;

        if (ar) {
            for (var i = 0; i < ar.length; i++) {
                const ardt = ar[i];
                if (ardt.getFullYear() === dt.getFullYear() && ardt.getMonth() === dt.getMonth() && ardt.getDate() === dt.getDate()) {
                    ret = true;
                    break;
                }
            }
        }

        return ret;
    }

    requestScheduleByMonth = (month, dt) => {
        month = this.state.lastSelectedMonth !== -1 && this.state.lastSelectedMonth > dt.getMonth() ? month : month - 1;
        let start = new Date(dt.getFullYear(), month, 1);
        let end = new Date(dt.getFullYear(), month + 1, 0);
    }

    stupidDatePickerHack = dt => {
        // turn a string containing YYYY-MM-DD into one containing MM-DD-YYYY
        if (!dt) {
            let today = Tools.toJSDate(new Date());
            dt = Tools.dateSimpleFormat(today);
        }

        let parts = dt.split('-');
        return parts && parts.length > 1 ? `${parts[1].toString().padStart(2, "0")}-${parts[2].toString().padStart(2, "0")}-${parts[0]}` : null;
    }

    getEndDate = dtStart => {
        let dtEnd = new Date(dtStart);
        dtEnd.setDate(1);
        let next = dtEnd.getDate() + 30;
        dtEnd.setDate(next);
        return dtEnd;
    }

    onGoNext = success => {
        if (!success && !this.timeSelected) {
            this.setState({ showAsInvalid: true });
        }
    }

    //Reset the invalid flag.
    resetShowInValid = () => {
        const { showAsInvalid } = this.state;
        if (this.mounted && showAsInvalid) {
            this.setState({ showAsInvalid: false });
        }
        logUI("MBHWeb.UI.CovidVaccine.AppointmentInfo.ResetShowInValid", new Date(), Tools.getURLPath());
    }

    renderSlots = () => {
        let selectedCalendarSlots = this.selectedMonthData && this.selectedMonthData.length > 0 && this.selectedMonthData.filter((slot) => {
            const selectedMoment = moment(this.state.selectedCalendarDate, 'YYYY-MM-DD');
            if (moment(slot.date, 'YYYY-MM-DD').isSame(selectedMoment,'day')) { // Passing in day will check day, month, and year.
                return slot;
            }
        });
        
        if (this.state.selectedCalendarDate === null && this.selectedMonthData && this.selectedMonthData.length > 0)
            selectedCalendarSlots = this.selectedMonthData;
        return (
            <div className="row">
                <div className="col-12">
                    {selectedCalendarSlots && selectedCalendarSlots.length > 0 &&
                        <div className="covid-type-container"> 
                            <span className="covid-type-heading">Vaccine: </span>
                            <span className="covid-type-name">{selectedCalendarSlots[0].providerMessage ? selectedCalendarSlots[0].providerMessage : "Vaccine unspecified"}</span>
                        </div>
                    }
                </div>
                <div className="col-12">
                    {selectedCalendarSlots && selectedCalendarSlots.length > 0 && selectedCalendarSlots[0].times && selectedCalendarSlots[0].times.length > 0 ? selectedCalendarSlots[0].times.map((slots, index) => (
                        <label className="appt-btn-container" key={index} onClick={(e) => {
                            this.setState({
                                selectedSlot: slots,
                                providerMessage: selectedCalendarSlots[0].providerMessage
                            });
                            logUI("MBHWeb.UI.CovidVaccine.AppointmentInfo.SelectCalenderSlotClick", new Date(), Tools.getURLPath());
                        }}>
                            <input type="radio" id={`${slots.timeString}`} name="timesRadioGroup" defaultChecked={this.state.selectedSlot && slots.startTime === this.state.selectedSlot.startTime}
                            />
                            <div className="btn btn-primary">{slots.timeString}</div>
                        </label>)) : <div className="error-msg">There are no times available on the selected day at this location. Please select a different day.</div>
                    }
                </div>
            </div>)
    }

    render() {
        const { providerData, providerSearchModel, searchRunning, searchErrored, visit } = this.props;
        const { lastSelectedMonth, selectedCalendarDate, selectedCalendarDay, selectedSlot } = this.state;
        let selectedDate = "";
        const locations = providerData && providerData.provider && providerData.provider.locations && providerData.provider.locations.length > 0 ? providerData.provider.locations : [];
        const openSchedule = locations && locations.length > 0 && locations[0].openSchedules && locations[0].openSchedules.dateAndTimes && locations[0].openSchedules.dateAndTimes.length > 0 ? locations[0].openSchedules.dateAndTimes : [];

        const locationDetails = locations ? locations.map((loc, i) => {
            return (<React.Fragment key={i}>
                {loc.locationName && <span>{' '}| {loc.locationName}</span>}
                {loc.locationStreet1 &&
                    <span>{' '}| <a key={i} className={loc.locationStreet1 ? "directions-link" : "no-link"} onClick={() => this.redirectToMap(loc)}>
                        <span className="loc-address"><span><span className="item-street">{loc.locationStreet1}</span>{loc.locationStreet2 && <span className="item-suite">, {loc.locationStreet2}</span>}</span><span className="item-city">, {loc.locationCity}</span><span className="item-state">, {loc.locationState}</span><span className="item-zip"> {loc.locationZip}</span> </span>
                    </a></span>
                }
            </React.Fragment>
            );
        }) : [];

        const visitTypeName = openSchedule && openSchedule.length > 0 && openSchedule[0].times && openSchedule[0].times.length > 0 && openSchedule[0].times[0].visitTypeDisplayName ? openSchedule[0].times[0].visitTypeDisplayName : "COVID-19 Vaccine";
        // calendar items...
        const calendarSlots = openSchedule && openSchedule.length > 0 ? openSchedule.map((slot, i) => { return slot.date; }) : [];
        const selectedDays = openSchedule && openSchedule.length > 0 ? openSchedule.map((slot, i) => { return this.parseDate(slot.date); }) : [];
        const defaultSelectedDay = selectedCalendarDay === null ? selectedDays && selectedDays.length > 0 ? selectedDays[0] : Tools.toJSDate(new Date()) : selectedCalendarDay;
        this.visitDataForProvider = this.getVisitDataForProvider(providerData);
        this.selectedMonthData = this.getSlotsForMonth(lastSelectedMonth);

        let calInitialDate = null;
        if (this.selectedMonthData && this.selectedMonthData.length > 0) {
            calInitialDate = Tools.toJSDate(this.selectedMonthData[0].date, DATE_FORMAT);
            selectedDate = Tools.dateSimpleFormat(calInitialDate);
        }

        let calMinDate = Tools.toJSDate(calInitialDate);
        if (calMinDate) calMinDate.setDate(1);
        if (selectedCalendarDate) {
            selectedDate = selectedCalendarDate;
        }

        return (
            <div style={this.props.style}>
                {openSchedule && openSchedule.length > 0
                    ? <React.Fragment>
                        <div className="schedule-appointment-info-container covid-vaccine-appt-info-container">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="step-heading">When would you like to schedule this appointment?</h1>
                                    <p className="step-description bold-heading">{visitTypeName}
                                        {locationDetails}</p>
                                </div>
                            </div>
                            {
                                <div className="row">
                                    <div className="col-12 col-md-6" id="schedule-calendar">
                                        <DatePicker
                                            initialDate={calInitialDate}
                                            minDate={calendarSlots && calendarSlots.length > 0 && new Date(calendarSlots[0])}
                                            value={this.stupidDatePickerHack(selectedDate)}
                                            isInline
                                            onClick={(day) => {
                                                if (this.containsDate(selectedDays, day)) {
                                                    this.setState({ selectedCalendarDate: `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`, selectedCalendarDay: day });
                                                    this.resetShowInValid();
                                                }
                                            }}
                                            onMonthChange={(dt) => {
                                                this.setState({ lastSelectedMonth: dt.getMonth() }, () => {
                                                    const selectedMonthDate = this.selectedMonthData && this.selectedMonthData.length > 0 && new Date(this.selectedMonthData[0].date);
                                                    this.setState({ selectedCalendarDate: `${selectedMonthDate.getFullYear()}-${selectedMonthDate.getMonth() + 1}-${selectedMonthDate.getDate()}`, selectedCalendarDay: selectedMonthDate });
                                                });
                                                    this.resetShowInValid();
                                            }}
                                            disabled={calendarSlots.length < 1}
                                            maxDate={new Date(calendarSlots[calendarSlots.length - 1])}
                                            enabledDays={selectedDays}
                                            selectedDays={defaultSelectedDay}
                                        />
                                        <div className="appointment-emergency-info">
                                            If this is an emergency, please contact 911.
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 schedule-time-slots-container">
                                        {searchRunning
                                            ?
                                            <div className="row overlay-loading-container">
                                                <div className="col-12 align-self-center">
                                                    <MiniSpinner />
                                                </div>
                                            </div>
                                            :
                                            <>{searchErrored && <div className="not-available-msg">We are not able to display times for this appointment type and location. Please try again later.</div>}</>
                                        }
                                        <div className="schedule-time-slots" role="radiogroup" aria-label="Available appointment times">
                                            {this.renderSlots()}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="row covid-vaccine-appt-info-button-container">
                            <div className="col-12">
                                <div className="footer-buttons">
                                    <button type="button" className="btn btn-primary" disabled={!selectedSlot} onClick={() => { this.doReviewAndSubmit() }}>REVIEW & SUBMIT</button>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    : !searchRunning && <Covid19AppointmentError providerSearchModel={providerSearchModel} xid={visit && visit.xid ? visit.xid : ""} />
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        scheduleDaysAvailable: state.openScheduling.scheduleDaysAvailable,
        searchRunning: state.providers.searchRunning,
        searchErrored: state.providers.error
    }
}

export default connect(mapStateToProps, null, null, { withRef: true })(Covid19VaccineAppointmentInfo);